import Existing from 'assets/icons/fa/circle-xmark-regular.svg'

Existing.displayName = 'Existing'
export default Existing
